import { CollectionItem, DriveItem, FolderItem } from '@/drive/entities/DriveItem/DriveItem';
import type { DriveNode } from '@/drive/entities/DriveNode';
import { CollectionTreeItem } from '@/drive/entities/DriveTreeItem/CollectionTreeItem';
import { FolderTreeItem } from '@/drive/entities/DriveTreeItem/FolderTreeItem';
import { GlobalAccessLevel } from '@/security/constants/GlobalAccessLevel';

import { DriveContainerId } from '../DriveItemId';

export interface DriveTreeItem {
  id: StringOrNumber;
  title: string;
  collapsed?: boolean;
  children?: DriveTreeItem[];
  setTitle(title: string): void;
  getUrl(): string;
  getDriveId(): DriveContainerId;
  getAccess(): GlobalAccessLevel;
}

export function canBeUsedInTree(item: DriveItem): item is FolderItem | CollectionItem {
  return item instanceof FolderItem || item instanceof CollectionItem;
}

export function toTreeNode(item: DriveItem): Nullable<DriveNode> {
  return canBeUsedInTree(item) ? item.toNode() : null;
}

export function fromDriveNode(item: DriveNode): DriveTreeItem {
  if (item.type === 'folder') {
    return new FolderTreeItem(item);
  }

  return new CollectionTreeItem(item);
}

export function fromDriveItem(item: FolderItem | CollectionItem): DriveTreeItem {
  if (item instanceof FolderItem) {
    return new FolderTreeItem(item);
  }

  return new CollectionTreeItem(item);
}
